'use strict';

var jsxRuntime = require('react/jsx-runtime');

const JobsSymbol = ({ className, variant })=>{
    if (variant === 'disabled') {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            className: className,
            "data-testid": "design-system-logo--jobs-symbol-disabled",
            children: [
                jsxRuntime.jsx("path", {
                    opacity: "0.7",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.25 20.9975L5 16.1404V7.10889L12.25 11.804V20.9975Z",
                    fill: "#BDBDBD"
                }),
                jsxRuntime.jsx("path", {
                    opacity: "0.6",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M5 16.1725L12.25 11.8965V3L5 7.12171V16.1725Z",
                    fill: "#BDBDBD"
                }),
                jsxRuntime.jsx("path", {
                    opacity: "0.5",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.7407 18.6397L15.9142 14.2197L15.7588 5.32581L8.58276 9.59022L8.7407 18.6397Z",
                    fill: "#BDBDBD"
                }),
                jsxRuntime.jsx("path", {
                    opacity: "0.4",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.25 20.9999L19.5 16.1428V7.11133L12.25 11.8064V20.9999Z",
                    fill: "#BDBDBD"
                })
            ]
        });
    }
    if (variant === 'bluegray') {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            className: className,
            "data-testid": "design-system-logo--jobs-symbol-bluegray",
            children: [
                jsxRuntime.jsx("path", {
                    opacity: "0.7",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.25 20.9975L5 16.1404V7.10889L12.25 11.804V20.9975Z",
                    fill: "#787D85"
                }),
                jsxRuntime.jsx("path", {
                    opacity: "0.6",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M5 16.1725L12.25 11.8965V3L5 7.12171V16.1725Z",
                    fill: "#787D85"
                }),
                jsxRuntime.jsx("path", {
                    opacity: "0.5",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.74082 18.6397L15.9143 14.2197L15.7589 5.32581L8.58289 9.59022L8.74082 18.6397Z",
                    fill: "#787D85"
                }),
                jsxRuntime.jsx("path", {
                    opacity: "0.4",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.25 20.9999L19.5 16.1428V7.11133L12.25 11.8064V20.9999Z",
                    fill: "#787D85"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        "data-testid": "design-system-logo--jobs-symbol",
        children: [
            jsxRuntime.jsx("path", {
                opacity: "0.7",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.25 20.9975L5 16.1404V7.10889L12.25 11.804V20.9975Z",
                fill: "#006DFF"
            }),
            jsxRuntime.jsx("path", {
                opacity: "0.6",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 16.1725L12.25 11.8965V3L5 7.12171V16.1725Z",
                fill: "#006DFF"
            }),
            jsxRuntime.jsx("path", {
                opacity: "0.5",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.7407 18.6397L15.9142 14.2197L15.7588 5.32581L8.58276 9.59022L8.7407 18.6397Z",
                fill: "#006DFF"
            }),
            jsxRuntime.jsx("path", {
                opacity: "0.4",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.25 20.9999L19.5 16.1428V7.11133L12.25 11.8064V20.9999Z",
                fill: "#006DFF"
            })
        ]
    });
};

module.exports = JobsSymbol;
